import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
// Importar la interfaz y el servicio actualizado
import { SolicitarVisitaService, PagedRequestOptions } from 'src/app/services/solicitar-visita.service';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EspecialidadesService } from 'src/app/services/especialidades.service';
import { StorageService } from 'src/app/services/storage.service';
import { Subscription, Subject, merge, of as observableOf } from 'rxjs';
import { debounceTime, distinctUntilChanged, startWith, switchMap, catchError } from 'rxjs/operators';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule, MatSnackBar } from '@angular/material/snack-bar';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { PaginatorIntl } from 'src/app/paginator-intl';
import { CambiarTecnicoDialogComponent } from './cambiar-tecnico-dialog/cambiar-tecnico-dialog.component';
import { SeleccionActivosDialogComponent } from '../seleccion-activos-dialog/seleccion-activos-dialog.component';
import { SolicitudVisitaActivoService } from 'src/app/services/solicitud-visita-activo.service';
import { SharedModule } from '@app/shared/shared.module';
import { TipoServicioService } from '@app/services/tipo-servicio.service';
import { ClientesService } from '@app/services/clientes.service';

@Component({
  selector: 'app-solicitudes-aprobadas',
  standalone: true,
  imports: [
    CommonModule, MatTableModule, MatPaginatorModule, MatSortModule,
    MatButtonModule, MatIconModule, MatCardModule, MatFormFieldModule,
    MatInputModule, RouterModule, MatProgressSpinnerModule, MatTooltipModule,
    MatDialogModule, MatSnackBarModule, CambiarTecnicoDialogComponent,
    MatSelectModule, SharedModule
  ],
  templateUrl: './solicitudes-aprobadas.component.html',
  styleUrls: ['./solicitudes-aprobadas.component.scss'],
  providers: [
    { provide: MatPaginatorIntl, useClass: PaginatorIntl }
  ]
})
export class SolicitudesAprobadasComponent implements OnInit, AfterViewInit, OnDestroy {
  baseDisplayedColumns: string[] = [
    'id', 
    'cliente', 
    'local', 
    'direccion',      // Campo Dirección añadido (CR-202607-0011)
    'comuna',         // Campo Comuna añadido (CR-202607-0011)
    'zona',
    'especialidad',
    'fechaIngreso', 
    'fechaVisita',
    'ticketGruman',     
    'generada_por',
    'tipoServicio', 
    'tipo_solicitud',
    'tiempo_restante',  // Campo Tiempo Restante SLA añadido (CR-202607-0011)
    'observaciones', 
    'tecnico'
  ];
  displayedColumns: string[] = [...this.baseDisplayedColumns]; // Array dinámico
  dataSource = new MatTableDataSource<any>();
  loading = true;
  totalItems = 0;
  selectedServiceType: string = '';
  tiposServicio: any[] = [];

  selectedCompany: any = null;
  public isGruman: boolean = false;
  public clientes: any[] = [];
  public selectedClientId: number | null = null;
  private companySubscription: Subscription | null = null;
  private searchSubject = new Subject<string>();

  especialidades: { [key: number]: string } = {};

  meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
  anios: number[] = [];
  selectedMes: string = '';
  selectedAnio: string = '';

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('input') input!: ElementRef;

  constructor(
    private solicitarVisitaService: SolicitarVisitaService,
    private especialidadesService: EspecialidadesService,
    private tipoServicioService: TipoServicioService,
    private router: Router,
    private route: ActivatedRoute,
    private storage: StorageService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private clientesService: ClientesService,
    private solicitudVisitaActivoService: SolicitudVisitaActivoService
  ) {}

ngOnInit() {
    this.generarAnios();
    this.loadEspecialidades();
    this.getTiposServicio();

    // Capturar si venimos desde el Dashboard con un mes específico
    this.route.queryParams.subscribe((params: any) => {
      if (params['mesFacturacion']) {
        const parts = params['mesFacturacion'].split(' ');
        if (parts.length === 2) {
          this.selectedMes = parts[0];
          this.selectedAnio = parts[1];
        }
      }
    });
    
    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged()
    ).subscribe(() => {
      this.paginator.pageIndex = 0;
      this.loadSolicitudes();
    });
    
    this.companySubscription = this.storage.companyChange$.subscribe((company: any) => {
      this.selectedCompany = company;

      this.isGruman = this.selectedCompany?.nombre?.trim().toUpperCase() === 'GRUMAN';
      this.selectedClientId = null;
      if (this.isGruman) {
        this.loadClientes();
      }
      
      this.updateDisplayedColumns(this.selectedCompany);

      if (this.paginator) {
        this.paginator.pageIndex = 0;
        this.loadSolicitudes();
      }
    });

    const user = this.storage.getItem('currentUser');
    if (user && user.selectedCompany) {      
      this.selectedCompany = user.selectedCompany;
      //  Inicializar el filtro de cliente en la carga si es GRUMAN
      this.isGruman = this.selectedCompany.nombre?.trim().toUpperCase() === 'GRUMAN';
      this.updateDisplayedColumns(this.selectedCompany);
      if (this.isGruman) {
        this.loadClientes();
      }
    } else {      
      this.updateDisplayedColumns(null);
    }
  }

  ngAfterViewInit() {
    // Carga los datos cuando el usuario cambia de página o el orden
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(startWith({}))
      .subscribe(() => this.loadSolicitudes());
  }

  ngOnDestroy() {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
  }

  getTiposServicio(): void {
    this.tipoServicioService.findAll().subscribe({
      next: (data: any) => {
        this.tiposServicio = data;
      },
      error: (err: any) => console.error('Error cargando tipos de servicio', err)
    });
  }
  
  private updateDisplayedColumns(company: any) {
    // Comienza con las columnas base
    const newCols = [...this.baseDisplayedColumns];
    let esGruman = false;

    // Verificación robusta contra espacios o mayúsculas
    if (company && company.nombre) {
      const nombreLimpio = company.nombre.trim().toUpperCase();
      if (nombreLimpio === 'GRUMAN') {
        esGruman = true;
      }
    }

    // Añade la columna 'acciones' solo si es Gruman
    if (esGruman) {
      newCols.push('acciones');
      newCols.splice(2, 0, 'cliente');
    }

    // Asigna el nuevo array de columnas
    this.displayedColumns = newCols;
  }

  generarAnios(): void {
    const currentYear = new Date().getFullYear();
    for (let y = 2023; y <= currentYear + 2; y++) {
      this.anios.push(y);
    }
  }

  onDateFilterChange() {
    if (this.paginator) this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  loadEspecialidades() {
    this.especialidadesService.findAll().subscribe({
      next: (data: any[]) => {
        this.especialidades = data.reduce((acc, esp) => {
          acc[esp.id] = esp.nombre;
          return acc;
        }, {});
      },
      error: (error: any) => console.error('Error cargando especialidades:', error)
    });
  }

  // Cargar catálogo de clientes para el dropdown
  loadClientes(): void {
    this.clientesService.getClientesWithGruman().subscribe({
      next: (clientes: any[]) => this.clientes = clientes || [],
      error: (err: any) => console.error('Error al cargar clientes:', err)
    });
  }

  // Evento al seleccionar un cliente en la vista GRUMAN
  onClientFilterChange(): void {
    if (this.paginator) this.paginator.pageIndex = 0;
    this.loadSolicitudes();
  }

  loadSolicitudes() {
    this.loading = true;

    let mesFacturacionStr = '';
    if (this.selectedMes) mesFacturacionStr += this.selectedMes;
    if (this.selectedAnio) mesFacturacionStr += (mesFacturacionStr ? ' ' : '') + this.selectedAnio;

    // 1. Construir el objeto de opciones para la paginación
    const options: PagedRequestOptions = {
      page: this.paginator.pageIndex + 1,
      limit: this.paginator.pageSize,
      searchTerm: this.input.nativeElement.value,
      serviceType: this.selectedServiceType,
      sortBy: this.sort.active || 'id',
      sortOrder: this.sort.direction || 'desc',
      mesFacturacion: mesFacturacionStr || undefined
    };

    // Asignar clientId según si es GRUMAN o cliente normal
    if (this.isGruman) {
      if (this.selectedClientId) {
        options.clientId = this.selectedClientId;
      }
    } else if (this.selectedCompany?.id) {
      options.clientId = this.selectedCompany.id;
    }

    // 2. Llamar al servicio refactorizado con el objeto de opciones
    this.solicitarVisitaService.getSolicitudesAprobadasPaginado(options)
    .pipe(
      catchError(() => observableOf(null))
    ).subscribe((response: any) => {
      this.loading = false;
      if (response && response.data) {
          this.dataSource.data = response.data;
          this.totalItems = response.total;
      } else {
          this.dataSource.data = [];
          this.totalItems = 0;
      }
    });
  }

  applyFilter() {
    this.searchSubject.next(this.input.nativeElement.value);
  }

  onServiceTypeChange() {
    this.paginator.pageIndex = 0; // Volvemos a la página 1
    this.loadSolicitudes();       // Recargamos la tabla
  }

  resetFilters() {
    this.input.nativeElement.value = '';
    this.selectedServiceType = '';
    this.selectedClientId = null;
    this.paginator.pageIndex = 0;
    this.sort.active = 'id';
    this.sort.direction = 'desc';
    this.selectedMes = '';
    this.selectedAnio = '';
    this.getTiposServicio();
    this.loadSolicitudes();
  }

  canViewDetail(row: any): boolean {
    if (row.facturacion && (row.facturacion.is_cerrada === true || row.facturacion.is_cerrada === 1)) {
      return false;
    }
    return true;
  }

  verDetalle(id: number) {
    this.router.navigate(['transacciones/solicitudes-de-visita/ver-solicitud/aprobada', id]);
  }

  exportarExcel() {
    Swal.fire({
      title: 'Generando exportación...',
      text: 'Esto puede tardar unos segundos, por favor espera.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading()
    });

    let mesFacturacionStr = '';
    if (this.selectedMes) mesFacturacionStr += this.selectedMes;
    if (this.selectedAnio) mesFacturacionStr += (mesFacturacionStr ? ' ' : '') + this.selectedAnio;

    // 1. Construir las opciones
    const options: PagedRequestOptions = {
      export: true, 
      searchTerm: this.input?.nativeElement?.value || '',
      serviceType: this.selectedServiceType,
      sortBy: this.sort?.active || 'id',
      sortOrder: this.sort?.direction || 'desc',
      mesFacturacion: mesFacturacionStr || undefined,
      status: 'aprobada'
    };

    // Lógica de asignación de cliente para exportación
    if (this.isGruman) {
      if (this.selectedClientId) {
        options.clientId = this.selectedClientId;
      }
    } else if (this.selectedCompany?.id) {
      options.clientId = this.selectedCompany.id;
    }
    
    // 2. Llamada al servicio
    this.solicitarVisitaService.descargarExcelSolicitudes(options).subscribe({
      next: (response: any) => {
        if (!response || !response.data) {
          Swal.fire('Sin datos', 'No se encontraron solicitudes para exportar.', 'warning');
          return;
        }

        // 3. Delegar la generación del Excel al servicio maestro
        this.solicitarVisitaService.exportarExcelMaestro(response.data, 'Aprobadas');
      },
      error: (err: any) => {
        console.error('Error al exportar:', err);
        Swal.close();
        Swal.fire('Error', 'Hubo un problema al generar el Excel.', 'error');
      }
    });
  }

  // Dentro de la clase SolicitudesAprobadasComponent
  abrirModalCambiarTecnico(solicitud: any): void {
    const dialogRef = this.dialog.open(CambiarTecnicoDialogComponent, {
      width: '600px',
      data: { 
        solicitudId: solicitud.id,
        tecnicoActual: solicitud.tecnico_asignado,
        clienteNombre: solicitud.client?.nombre,
        localNombre: solicitud.local?.nombre_local
      }
    });

    dialogRef.afterClosed().subscribe((result:any) => {
      if (result) {
        this.loading = true;
        // Llamada al servicio que actualizamos anteriormente
        this.solicitarVisitaService.cambiarTecnico(solicitud.id, result.tecnicoId, 'tecnico').subscribe({
          next: () => {
            this.snackBar.open('Técnico actualizado exitosamente', 'Cerrar', { duration: 3000 });
            this.loadSolicitudes();
          },
          error: (err: any) => {
            this.loading = false;
            Swal.fire('Error', err.error?.message || 'No se pudo cambiar el técnico', 'error');
          }
        });
      }
    });
  }

  abrirModalAsignarActivos(solicitud: any): void {
    // Primero obtener los activos ya asignados
    this.solicitudVisitaActivoService.getActivosAsignados(solicitud.id).subscribe({
      next: (asignados: any[]) => {
        const preSelectedIds = asignados.map((a: any) => a.activoFijoLocal?.id || a.activo_fijo_local_id);

        const dialogRef = this.dialog.open(SeleccionActivosDialogComponent, {
          width: '800px',
          maxHeight: '80vh',
          data: {
            localId: solicitud.local?.id || solicitud.localId,
            preSelectedIds: preSelectedIds,
          },
        });

        dialogRef.afterClosed().subscribe((selectedIds: number[] | undefined) => {
          if (selectedIds !== undefined) {
            this.solicitudVisitaActivoService.asignarActivos(solicitud.id, selectedIds).subscribe({
              next: () => {
                this.snackBar.open(
                  `${selectedIds.length} activo(s) asignado(s) correctamente`,
                  'Cerrar',
                  { duration: 3000 }
                );
              },
              error: (err: any) => {
                Swal.fire('Error', err.error?.message || 'No se pudieron asignar los activos', 'error');
              }
            });
          }
        });
      },
      error: (err: any) => {
        // Si no hay asignados, abrir el dialog vacío
        const dialogRef = this.dialog.open(SeleccionActivosDialogComponent, {
          width: '800px',
          maxHeight: '80vh',
          data: {
            localId: solicitud.local?.id || solicitud.localId,
            preSelectedIds: [],
          },
        });

        dialogRef.afterClosed().subscribe((selectedIds: number[] | undefined) => {
          if (selectedIds !== undefined) {
            this.solicitudVisitaActivoService.asignarActivos(solicitud.id, selectedIds).subscribe({
              next: () => {
                this.snackBar.open(
                  `${selectedIds.length} activo(s) asignado(s) correctamente`,
                  'Cerrar',
                  { duration: 3000 }
                );
              },
              error: (err2: any) => {
                Swal.fire('Error', err2.error?.message || 'No se pudieron asignar los activos', 'error');
              }
            });
          }
        });
      }
    });
  }

  esPreventivo(solicitud: any): boolean {
    return solicitud.tipoServicioId === 3 && solicitud.client?.apply_fixed_asset;
  }

  //  Formateador homologado para transformar horas decimales a formato de días, horas y minutos (CR-202607-0011)
  formatTiempoRestante(horas: number | undefined | null): string {
    if (horas === undefined || horas === null || isNaN(horas)) return '-';
    
    const esNegativo = horas < 0;
    const absolutoHoras = Math.abs(horas);
    
    const dias = Math.floor(absolutoHoras / 24);
    const hrs = Math.floor(absolutoHoras % 24);
    const mins = Math.round((absolutoHoras % 1) * 60);
    
    let resultado = '';
    if (dias > 0) resultado += `${dias}d `;
    if (hrs > 0 || dias > 0) resultado += `${hrs}h `;
    resultado += `${mins}m`;
    
    return esNegativo ? `-${resultado.trim()}` : resultado.trim();
  }
}